(ns ui.components.radix-ui.tooltip.view
  (:require
   [ui.components.tooltip.zapkit-styles :as zapkit-styles]
   [ui.components.zapkit-variants :as variants]
   [ui.util :as uu]
   [react :as react]
   [oops.core :as oops]
   ["@radix-ui/react-tooltip" :as Tooltip]
   [reagent.core :as r]))

(defn adapt
  ([cls-name]
   (r/adapt-react-class (oops/oget+ Tooltip cls-name)))
  ([parent-cls cls-name]
   (r/adapt-react-class (oops/oget+ (oops/oget+ Tooltip parent-cls) cls-name))))


(def tooltip-provider (adapt "Provider"))
(def tooltip-root (adapt "Root"))
(def tooltip-trigger (adapt "Trigger"))
(def tooltip-portal (adapt "Portal"))
(def tooltip-content (adapt "Content"))
(def tooltip-arrow (adapt "Arrow"))


(def default-props
  {:align          :center
   :delay-duration 500
   :side           :top
   :side-offset    5})

(def tooltip-z-index 30000010)

(defn forward-ref
  [props-render-fn]
  (react/forwardRef
   (fn [props ref]
     (r/as-element
      (props-render-fn (assoc (js->clj props :keywordize-keys true)
                              :ref ref))))))

(defn tw2-style?
  "True when the tooltip has the ZapKit style. A tooltip has it when its props have
   `:style-variant :tw2`."
  [props]
  (= :tw2 (:style-variant props)))

(defn tw2-bubble-class
  "The classes of the bubble of the ZapKit style Tooltip, for the `side` of the
   trigger that the bubble is on."
  [side]
  (variants/slot-class (:bubble zapkit-styles/tooltip)
                       {:position (or side :top)
                        :visible  true}))

(defn tw2-portal
  "The portal of a tooltip with the ZapKit style. The content of a portal is in the
   body of the page, outside the `.tw2` scope of the page, and the tw2 classes only
   work inside that scope. So the content has a `.tw2` element around it. The
   bubble has no arrow, as the ZapKit Tooltip has none."
  [{:keys [side side-offset align disabled? content-element]}]
  [tooltip-portal
   [:div
    {:class "tw2"}
    (when-not disabled?
      [tooltip-content
       {:class      (tw2-bubble-class side)
        :sideOffset side-offset
        :align      align
        :side       side
        :style      {:z-index tooltip-z-index}}
       content-element])]])

(defn view
  ([trigger-element content-element]
   [view default-props trigger-element content-element])
  ([props trigger-element content-element]
   (let [{:keys [align as-child? delay-duration side side-offset
                 trigger-class content-class]} (merge default-props props)]
     [tooltip-provider
      [tooltip-root
       {:delayDuration delay-duration}
       (if as-child?
         [tooltip-trigger
          {:asChild true
           :class   "m-0 p-0"}
          [:>
           trigger-element]]
         [tooltip-trigger
          {:class (uu/cm "m-0 p-0" trigger-class)}
          trigger-element])
       (if (tw2-style? props)
         [tw2-portal {:side            side
                      :side-offset     side-offset
                      :align           align
                      :disabled?       (:disabled? props)
                      :content-element content-element}]
         [tooltip-portal
          {:style {:z-index tooltip-z-index}}
          (when-not (:disabled? props)
            [tooltip-content
             {:class      (uu/cm
                           "p-3 text-sm m-0 max-w-64"
                           "bg-secondary-gloomy text-secondary-gloomy-text rounded"
                           content-class)
              :sideOffset side-offset
              :align      align
              :side       side
              :style      {:z-index tooltip-z-index}}
             content-element
             [tooltip-arrow
              {:class "fill-secondary-gloomy"}]])])]])))

(defn as-child
  [props render-trigger-fn content-element]
  (let [{:keys [align delay-duration side side-offset]} (merge default-props props)]
    [tooltip-provider
     [tooltip-root
      {:delayDuration delay-duration}
      [tooltip-trigger
       {:asChild true
        :class   "m-0 p-0"}
       [:>
        (forward-ref render-trigger-fn)]]
      (if (tw2-style? props)
        [tw2-portal {:side            side
                     :side-offset     side-offset
                     :align           align
                     :disabled?       (:disabled? props)
                     :content-element content-element}]
        [tooltip-portal
         {:style {:z-index tooltip-z-index}}
         (when-not (:disabled? props)
           [tooltip-content
            {:class      (uu/cm "py-2 px-3 text-sm m-0 max-w-64 bg-secondary-gloomy text-secondary-gloomy-text border border-solid border-gloomy-regular-border-paler rounded")
             :sideOffset 5
             :align      align
             :side       side
             :style      {:z-index tooltip-z-index}}
            content-element
            [tooltip-arrow
             {:class "fill-secondary-gloomy"}]])])]]))
